<template>
  <!-- Modal -->
  <v-dialog class="delete-confirm-dialog" v-model="showDialog" width="400">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text v-html="question" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="decline(item)">{{$t('ModalConfirmDialog.cancel')}}</v-btn>
        <v-btn color="primary" text @click="confirm(item)">{{$t('ModalConfirmDialog.confirm')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    export default {
        name: 'ModalConfirmDialog',
        props: ['showDialog', 'title', 'question', 'item'],
        data() {
          return {
          }
        },
        /*watch: {
          showDialog: function (val) {
            this.dialog = val;
          },
        },*/
        methods: {
          confirm(item) {
            this.$emit('confirm', item);
            this.$emit('close', item);
          },
          decline(item) {
            this.$emit('decline', item);
            this.$emit('close', item);
          }
        },
    }
</script>

<style scoped>

</style>
